/*       */

import { gql } from '@apollo/client';

/**
 * Unified lightweight queries to fetch only the IDs of workspace resources
 * Used for filtering in AddResourcesModal to exclude already-added resources
 * These queries only fetch IDs, not full resource data, for optimal performance
 */

/**
 * Query to fetch all class resource IDs in a workspace
 */
export const loadWorkspaceClassResourceIdsQuery = gql`
    query loadWorkspaceClassResourceIdsQuery($id: ID!) {
        workspace(id: $id) {
            id
            classResources {
                class {
                    id
                }
            }
        }
    }
`;

/**
 * Query to fetch all entity resource IDs in a workspace
 */
export const loadWorkspaceEntityResourceIdsQuery = gql`
    query loadWorkspaceEntityResourceIdsQuery($id: ID!) {
        workspace(id: $id) {
            id
            entityResources(excludePermissions: true) {
                entity {
                    id
                }
            }
        }
    }
`;

/**
 * Query to fetch all team IDs in a workspace
 */
export const loadWorkspaceTeamIdsQuery = gql`
    query loadWorkspaceTeamIdsQuery($id: ID!) {
        workspace(id: $id) {
            id
            teams {
                team {
                    id
                }
            }
        }
    }
`;

/**
 * Generic query to fetch entity resource IDs by type (system_task, system_process, script)
 * Uses workspaceEntityResources with filterBy to fetch only IDs for specific entity types
 */
export const loadWorkspaceEntityResourceIdsByTypeQuery = gql`
    query loadWorkspaceEntityResourceIdsByTypeQuery($filterBy: [JSON]) {
        workspaceEntityResources(filterBy: $filterBy) {
            entity {
                id
            }
        }
    }
`;

